export const getSectionalCommitteeHistoryString = (
  nomination,
  sectionalCommitteeHistoryArray,
) => {
  if (!nomination) {
    return '';
  }

  const nominationId = nomination.id;
  const history = sectionalCommitteeHistoryArray.find(
    (item) =>
      item.attributes.nominationId === nominationId ||
      item.attributes.nominationId === Number(nominationId),
  );

  if (!history) {
    return '';
  }

  const attrs = history.attributes;
  const yearMappings = [
    { label: 'Year One', value: attrs.sectionalCommitteeYearOne },
    { label: 'Year Two', value: attrs.sectionalCommitteeYearTwo },
    { label: 'Year Three', value: attrs.sectionalCommitteeYearThree },
    { label: 'Year Four', value: attrs.sectionalCommitteeYearFour },
    { label: 'Year Five', value: attrs.sectionalCommitteeYearFive },
  ]
    .filter((year) => year.value && year.value.trim() !== '')
    .map((year) => `${year.label}: ${year.value}`);

  return yearMappings.join('\n');
};
